import { Component, Input, OnInit } from '@angular/core';
import { DTOShipment } from '../../../../@core/models/DTOShipment';
import { CrmAddressChangeDialogComponent } from '../dialogs/crm-address-change-dialog/crm-address-change-dialog.component';
import { CrmSendPodDialogComponent } from '../dialogs/crm-send-pod-dialog/crm-send-pod-dialog.component';
import { CrmNewTpslDialogComponent } from '../dialogs/crm-new-tpsl-dialog/crm-new-tpsl-dialog.component';
import { MatDialog } from '@angular/material';
import { StopService } from '../../../../@core/services/stop.service';
import { ShipmentService } from '../../../../@core/services/shipment.service';
import { LabelService } from '../../../../@core/services/label.service';
import { Router } from '@angular/router';
import { CrmUpdateShipmentDialogComponent } from '../dialogs/crm-update-shipment-dialog/crm-update-shipment-dialog.component';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'crm-navbar',
  templateUrl: './crm-navbar.component.html',
  styleUrls: ['./crm-navbar.component.scss']
})
export class CrmNavbarComponent implements OnInit {
  @Input() shipment: DTOShipment;
  @Input() userId: string;
  @Input() key: string;
  @Input() lang: string;
  @Input() waybill: string;
  showWaybillMenu: boolean = false;
  showRoutesMenu: boolean = false;

  constructor(
    public _stopService: StopService,
    public _labelService: LabelService,
    public dialog: MatDialog,
    public translate: TranslateService,
    private shipmentService: ShipmentService,
    private toastservice: ToastrService,
    private router: Router
  ) {
    if (
      router.parseUrl(this.router.url).root.children.primary.segments.length ===
        2 &&
      router.parseUrl(this.router.url).root.children.primary.segments[1]
        .path === 'routes'
    ) {
      this.showWaybillMenu = true;
    } else {
      this.showRoutesMenu = true;
    }
  }

  ngOnInit() {}

  openAddressChangeDialog(): void {
    let lang: string;
    if (this.lang === '1033') {
      lang = 'en';
    } else if (this.lang === '1036') {
      lang = 'fr';
    }
    const dialogRef = this.dialog.open(CrmAddressChangeDialogComponent, {
      width: '700px',
      height: '400px',
      position: { top: '50px' },
      data: {
        shipment: this.shipment,
        userId: this.userId,
        key: this.key,
        lang: lang
      }
    });
  }

  sendPOD() {
    
    const dialogRef = this.dialog.open(CrmSendPodDialogComponent, {
      width: '700px',
      height: '400px',
      position: { top: '50px' },
      data: {
        userId: this.userId,
        ShipmentId: this.shipment.ShipmentId,
        CustomerId: this.shipment.CustomerId,
        CustomerName: this.shipment.CustomerName,
        key: this.key
      }
    });
  }

  openEditShipmentDialog() {
    let lang: string;
    if (this.lang === '1033') {
      lang = 'en';
    } else if (this.lang === '1036') {
      lang = 'fr';
    }
    if (this.shipment.IsInvoiced) {
      this.toastservice.error(
        this.translate.instant('crm.lbl-update-shipment'),
        this.translate.instant('crm.err-update-shipment'),
        {
          positionClass: 'toast-top-center',
          disableTimeOut: false,
          enableHtml: true
        }
      );
    } else {
      const dialogRef = this.dialog.open(CrmUpdateShipmentDialogComponent, {
        width: '700px',
        height: '480px',
        position: { top: '50px' },
        data: {
          shipment: this.shipment,
          userId: this.userId,
          key: this.key,
          lang: lang
        }
      });
    }
  }

  openNewTPSLDialog() {
    let lang: string;
    if (this.lang === '1033') {
      lang = 'en';
    } else if (this.lang === '1036') {
      lang = 'fr';
    }
    const dialogRef = this.dialog.open(CrmNewTpslDialogComponent, {
      width: '800px',
      height: '600px',
      position: { top: '50px' },
      data: {
        StopHistory: this.shipment.StopHistory,
        userId: this.userId,
        key: this.key,
        lang: lang
      }
    });
  }

  printLabels() {
    this._labelService
      .printLabels([this.shipment.ShipmentId])
      .subscribe((result) => {});
  }

  private showAndDownloadPDF(blob: Blob) {
    const fileName = 'shipment_' + this.shipment.ShipmentId + '.pdf';
    const downloadURL = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = downloadURL;
    link.download = fileName;
    link.click();
    window.open(downloadURL); // This is blocked by adblock so we also need to download
  }
}
